/**
 * Size Tokens
 * Consistent sizing for component dimensions, icons, avatars, etc.
 * Use for width, height, and other size-related properties.
 */

export const sizes = {
  // Icon sizes
  iconXs: '16px',
  iconSm: '20px',
  iconMd: '24px',
  iconLg: '28px',
  iconXl: '32px',

  // Button and interactive element sizes
  buttonSm: '32px',
  buttonMd: '40px',
  buttonLg: '48px',
  buttonXl: '56px',

  // Avatar and profile image sizes
  avatarSm: '32px',
  avatarMd: '40px',
  avatarLg: '48px',
  avatarXl: '64px',
  avatar2xl: '84px',
  avatar3xl: '104px',

  // Card and container sizes
  cardSm: '200px',
  cardMd: '220px',
  cardLg: '280px',
  cardXl: '320px',

  // Content widths
  contentSm: '400px',
  contentMd: '480px',
  contentLg: '520px',
  contentXl: '640px',

  // Button widths
  buttonWidthMin: '240px',
  buttonWidthMax: '280px',

  // Minimum heights for interactive areas
  minTouchTarget: '44px',
  minTextArea: '120px',
  minCardHeight: '160px',
} as const;